import React from 'react';
import css from './title.module.css';

export default function Title({
  title,
  uppercase = true,
}: {
  title: string;
  uppercase?: boolean;
}) {
  return (
    <h1 className={css['title']}>{uppercase ? title.toUpperCase() : title}</h1>
  );
}
